import {
  GET_WORKORDER_ITEMS,
  GET_WORKORDER_ITEMS_SUCCESS,
  GET_WORKORDER_ITEMS_FAIL,
  ADD_WORKORDER_ITEM,
  ADD_WORKORDER_ITEM_SUCCESS,
  ADD_WORKORDER_ITEM_FAIL,
  UPDATE_WORKORDER_ITEM,
  UPDATE_WORKORDER_ITEM_SUCCESS,
  UPDATE_WORKORDER_ITEM_FAIL,
  DELETE_WORKORDER_ITEM,
  DELETE_WORKORDER_ITEM_SUCCESS,
  DELETE_WORKORDER_ITEM_FAIL,
  SET_WORKORDER_ITEM_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  workOrderItems: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const workOrderItemReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKORDER_ITEMS:
      return { ...state, loading: true }
    case GET_WORKORDER_ITEMS_SUCCESS:
      return { ...state, loading: false, workOrderItems: action.payload }
    case GET_WORKORDER_ITEMS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_WORKORDER_ITEM:
      return { ...state, loading: true }
    case ADD_WORKORDER_ITEM_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} } // Clear field errors on success
    case ADD_WORKORDER_ITEM_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_WORKORDER_ITEM:
      return { ...state, loading: true }
    case UPDATE_WORKORDER_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        fieldErrors: {}, // Clear field errors on success
      }
    case UPDATE_WORKORDER_ITEM_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_WORKORDER_ITEM:
      return { ...state, loading: true }
    case DELETE_WORKORDER_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_WORKORDER_ITEM_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_WORKORDER_ITEM_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default workOrderItemReducer
